import React from 'react';
import Modal from "react-bootstrap/Modal";
function AlertModal({showAlert, setShowAlert, error, message }) {
    return(
        <>
        {/* // modal notify */}
        <Modal 
            show={showAlert}
            onHide={() => setShowAlert(false)}
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header closeButton 
                id='contained-modal-title-vcenter'
                className={error ? "bg-danger text-white" : 'bg-success text-white'}
            >
                    <Modal.Title>ແຈ້ງເຕືອນ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {message}
            </Modal.Body>
        </Modal>
        </>
    );
}

export default AlertModal;